<template>
	<div>
    <app-board>Live Calls {{tableData.length}}</app-board>
    <app-board>
      <el-table
          height="500px"
          :data="tableData"
          style="width: 100%">
        <el-table-column
            label="Started"
            prop="created">
        </el-table-column>
        <el-table-column
            label="CID"
            prop="cid_num">
        </el-table-column>
        <el-table-column
            label="Codec"
            prop="write_codec">
        </el-table-column>
        <el-table-column
            label="Destination"
            prop="initial_dest">
        </el-table-column>
        <el-table-column
            label="Status"
            prop="callstate">
        </el-table-column>
        <el-table-column
            label="Duration"
            prop="duration">
          <template slot-scope="scope">
            <span class="text-success">{{ scope.row.duration }}</span>
          </template>
        </el-table-column>
      </el-table>
    </app-board>
  </div>
</template>

<script>


export default {
  props: {
    callDirection: {
      default: 'inbound'
    },
    getBy: {
      default: 'user'
    },
    targetEntityId: {
      default: false
    }
  },
  data () {
    return {
      durations: {},
      tableData: [],
      temp: '',
      entityId: false,
      compIsActive: true
    }
  },
  beforeDestroy() {
    this.compIsActive = false
  },
  methods: {
    ...$mapActions('voip-generate-live-user-active-calls-api', {
      getActiveCallsActions: 'get'}),
    formatDuration (datesDiff) {
      let hours = 0
      if (datesDiff > 3600000)  hours = Math.floor((datesDiff / (1000 * 60 * 60)) % 60);
      let minutes = Math.floor((datesDiff / (1000 * 60)) % 60);
      let seconds = Math.floor(((datesDiff / 1000) % 60))
      //let sec = seconds % 60
      if (hours < 10) hours = "0" + hours
      if (minutes < 10) minutes = "0" + minutes
      if (seconds < 10) seconds = "0" + seconds
      return hours + ":" + minutes + ":" + seconds
    },
    getActiveCalls () {
      this.getActiveCallsActions({ entityId: this.entityId, getBy:  this.getBy}).then( r => {
        if (r) {
          // let data = '[{"uuid":"08215635-815b-455b-9795-765296a11bc3","direction":"inbound","created":"2021-05-31 19:00:04","created_epoch":"1622487063","name":"sofia\\/internal\\/18193283250@46.4.181.37","state":"CS_EXECUTE","cid_name":"18193283250","cid_num":"18193283250","ip_addr":"46.4.181.37","dest":"*411","application":"lua","application_data":"directory.lua","dialplan":"XML","context":"104.131.190.194","read_codec":"PCMU","read_rate":"8000","read_bit_rate":"64000","write_codec":"PCMU","write_rate":"8000","write_bit_rate":"64000","secure":"","hostname":"FFR-Portal-Agents-Fusion-Server-6D","presence_id":"18193283250@46.4.181.37","presence_data":"","accountcode":"","callstate":"ACTIVE","callee_name":"","callee_num":"","callee_direction":"","call_uuid":"","sent_callee_name":"","sent_callee_num":"","initial_cid_name":"18193283250","initial_cid_num":"18193283250","initial_ip_addr":"46.4.181.37","initial_dest":"12044102092","initial_dialplan":"XML","initial_context":"public","domain_name":"104.131.190.194"}, {"uuid":"08215635-815b-455b-9795-765296a11bc3","direction":"inbound","created":"2021-05-31 18:51:03","created_epoch":"1622487063","name":"sofia\\/internal\\/18193283250@46.4.181.37","state":"CS_EXECUTE","cid_name":"18193283250","cid_num":"18193283250","ip_addr":"46.4.181.37","dest":"*411","application":"lua","application_data":"directory.lua","dialplan":"XML","context":"104.131.190.194","read_codec":"PCMU","read_rate":"8000","read_bit_rate":"64000","write_codec":"PCMU","write_rate":"8000","write_bit_rate":"64000","secure":"","hostname":"FFR-Portal-Agents-Fusion-Server-6D","presence_id":"18193283250@46.4.181.37","presence_data":"","accountcode":"","callstate":"ACTIVE","callee_name":"","callee_num":"","callee_direction":"","call_uuid":"","sent_callee_name":"","sent_callee_num":"","initial_cid_name":"18193283250","initial_cid_num":"18193283250","initial_ip_addr":"46.4.181.37","initial_dest":"12044102092","initial_dialplan":"XML","initial_context":"public","domain_name":"104.131.190.194"}]'
          let activeCalls = r;//JSON.parse(data)
          let call = null
          let timeDiff = null

          this.tableData = []
          for(let i in activeCalls) {
            call = activeCalls[i]
            if (call.direction != this.callDirection || !call.direction) continue;

            /*let uuid = call.uuid
            if (this.durations.hasOwnProperty(uuid)) {
              this.durations[uuid] = this.durations[uuid] + 1
              call.duration = this.durations[uuid]
            } else {
              this.durations[uuid] = 1
            }*/

            let now = (new Date());
            let cat = new Date(call.created)

            let CLT = new Date();
            let d1 = new Date(CLT.toUTCString());
            let d2 = Date.UTC(cat.getFullYear(), cat.getMonth(), cat.getDate(), cat.getHours(), cat.getMinutes(), cat.getSeconds());

            call.duration = this.formatDuration(Math.abs(d1 - d2))
            this.tableData.push(call)
          }
        }

      }).finally(() => {
        if (this.compIsActive) {
          setTimeout(() => {
            this.getActiveCalls()
          }, 990)
        }
      })
    }
  },
  mounted() {
    if (!this.targetEntityId && this.getBy == 'user') {
      this.entityId = $store.state['user-state'].profile.id;
    } else {
      this.entityId = this.targetEntityId
    }

    this.getActiveCalls()
  }
}
</script>
